import { Dialog, DialogSurface } from "@fluentui/react-components";
import styled from "styled-components";

export function AppSpinner() {
  return (
    <Dialog modalType="modal" open={true}>
      <StyledDialogSurface
        aria-label="Loading"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {/* Hidden focusable element to satisfy Fluent UI Dialog requirement */}
        <HiddenButton type="button" aria-label="Loading spinner" tabIndex={0} />
        <Container>
          <Content>
            <div
              className="loader"
              role="status"
              aria-live="polite"
              aria-label="Loading"
            ></div>
          </Content>
        </Container>
      </StyledDialogSurface>
    </Dialog>
  );
}

const StyledDialogSurface = styled(DialogSurface)`
  background-color: ${({ theme }) =>
    theme.palette?.blackTranslucent40} !important;
  width: 100%;
  max-width: 100% !important;
  height: 100vh;
  backdrop-filter: blur(1px);
`;

const HiddenButton = styled.button`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
  pointer-events: none;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  height: 100vh;
  max-width: 100%;

  .loader {
    width: 40px;
    height: 40px;
    border: 4px solid ${({ theme }) => theme.palette?.neutralLight || "#eaeaea"};
    border-top: 4px solid
      ${({ theme }) => theme.palette?.themePrimary || "#0078d4"};
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
